import { createFileRoute } from '@tanstack/react-router'

import { QuoteImportDetailPage } from '@/pages/quotes/import/[id]/QuoteImportDetailPage'

export const Route = createFileRoute('/_authenticated/_dashboard/quotes/import/$id/')({
  component: QuoteImportDetailPage,
})
